import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

export const EditorCustomPluginWrapper = ({ children, element }) => {
  let el = useRef(document.createElement("div"));
  useEffect(
    function initEffect() {
      let modalPlugin = document.getElementById(element);
      let refElement = el.current;
      modalPlugin?.appendChild(refElement);

      return () => {
        modalPlugin?.removeChild(refElement);
      };
    },
    [element]
  );
  return element ? ReactDOM.createPortal(children, el.current) : null;
};
